export default "__VITE_ASSET__IBWJ9066__"